import React from 'react';

const Testimonials: React.FC = () => {
    return (
        <div className="container">
            <h1 className="text-center mb-4 animate__animated animate__fadeInDown">Testimonials</h1>
            <p className="text-center mb-5">What our clients say about Uma Shankar Security Agency</p>
            
            <div className="row">
                <div className="col-12">
                    <div className="card border-success animate__animated animate__fadeInUp">
                        <div className="card-body text-center p-5">
                            <h4 className="text-success mb-3">Coming Soon</h4>
                            <p className="lead">Client testimonials will be added here as they become available.</p>
                            <p className="text-muted">We are committed to providing exceptional security services and look forward to sharing our clients' experiences.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Testimonials;